// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nwEOChiclet":"_33P1kC","text":"_31quZt","nwLogoContainer":"_2YiHdp","sparkleImage":"OlWJRT"};